import SourceInstallPromptContainer from 'SourceComponent/InstallPrompt/InstallPrompt.container';
import isMobile from 'Util/Mobile';
import InstallPromptIOS from 'Component/InstallPromptIOS';
import InstallPromptAndroid from 'Component/InstallPromptAndroid';

export class InstallPromptContainer extends SourceInstallPromptContainer {
    render() {
        const { isBannerClosed } = this.state;

        if (
            isMobile.standaloneMode() ||
            isBannerClosed ||
            navigator.userAgent.match('CriOS') ||
            navigator.userAgent.toLowerCase().indexOf('firefox') > -1
        ) {
            return null;
        }

        if (isMobile.iOS()) {
            return <InstallPromptIOS { ...this.containerFunctions } />;
        }

        if (isMobile.android()) {
            return <InstallPromptAndroid { ...this.containerFunctions } />;
        }

        return null;
    }
}

export default InstallPromptContainer;
